<template>
    <Transition name="fade" mode="out-in">
        <slot></slot>
    </Transition>
</template>

<style lang="scss">

    .fade-enter-active,
    .fade-leave-active 
    {
        transition: opacity 300ms ease;
    }

    .fade-enter-from,
    .fade-leave-to 
    {
        opacity: 0;
    }

</style>